import { render } from "./VModalConfirmed.vue?vue&type=template&id=3ba6b3be"
import script from "./VModalConfirmed.vue?vue&type=script&lang=js"
export * from "./VModalConfirmed.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__